
import { useEffect, useRef, useState } from 'react';

import { Toast } from 'primereact/toast';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import { TreeNode } from 'primereact/treenode';
import { useSelector } from 'react-redux';
import '../../styles/menuLateralProcessoSelecionado.css';
import { Tooltip } from 'primereact/tooltip';
import { useNavigate } from "react-router-dom";
import { RootState } from '../../app/store';
import configUrls from '../../config/configUrls';
import { Documento } from '../../types/processo/Documento';
import { useGetDocumentosByProcessoQuery } from '../iniciarDocumento/createDocumento/documentoApiSlice';
import { ISprocesso } from '../../types/processo/Processo';
import errorFormat from '../../utils/errorFormat';
import { useSnackbar } from 'notistack';
import { Box, IconButton, Typography } from '@mui/material';



export const MenuLateralProcessoSelecionado = () => {

    interface DocumentoTree {
        key: string;
        label: string;
        data: string;
        icon: string;
        tip: string;
        link: string;
    }
    const [nodes, setNodes] = useState<TreeNode[]>([]);

    const [selectedNodeKey, setSelectedNodeKey] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>('');
    const toast = useRef<Toast>(null);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const navigate = useNavigate();

    const [expandedKeys, setExpandedKeys] = useState<any>({}); // Estado para os nós expandidos






    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);

    useEffect(() => {
        if (!processoSelecionado) {
            navigate(configUrls.PROCESSO_LIST_RT);
            return;
        }

        const documentosTree = processoSelecionado.documentos.map((doc, index) => ({
            key: `${index + 1}`,
            label: doc.nomeArvore ?? '',
            data: doc.id,
            icon: 'pi pi-fw pi-file',
            tip: doc.descricao ?? '',
            link: `${configUrls.PROCESSO_DOCUMENTO_VIEW_LK}${doc.id}`
        }));

        // <Link to={`${configUrls.PROCESSO_FORM_VIEW_LK}${rowData.id}`}>

        const root = {
            key: '0',
            label: `Processo: ${processoSelecionado.numeroProcesso}`,
            data: 'processoId',
            icon: 'pi pi-fw pi-folder',
            tip: processoSelecionado.tipoProcesso.nome,
            link: `${configUrls.PROCESSO_FORM_VIEW_LK}${processoSelecionado.id}`,
            children: documentosTree
        };

        setNodes([root]); // Atualiza os nodes com o root e os documentos

    }, [processoSelecionado, navigate]);



    useEffect(() => {

        if (nodes.length > 0) {
            expandAll();
        }
    }, [nodes]); // Chama quando `nodes` muda



    const onSelect = (event: any) => {
        if (event.node.link) {
            navigate(event.node.link);
        }
    };


    const expandAll = () => {
        let _expandedKeys = {};

        for (let node of nodes) {
            expandNode(node, _expandedKeys);
        }

        setExpandedKeys(_expandedKeys);
    };
    const expandNode = (node: TreeNode, _expandedKeys: any) => {
        if (node.children && node.children.length) {
            _expandedKeys[node?.key ?? 0] = true;

            for (let child of node.children) {
                expandNode(child, _expandedKeys);
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="w-[100%] p-1 h-screen bg-slate-300" >

                <Tooltip target=".tree-tip" />

                <Tree
                    expandedKeys={expandedKeys} // Propriedade para controlar os nós expandidos
                    onToggle={(e) => setExpandedKeys(e.value)} // Atualiza o estado de nós expandidos
                    value={nodes}
                    selectionMode="single"
                    selectionKeys={selectedNodeKey}
                    onSelectionChange={(e) => setSelectedNodeKey(e.value)}
                    onSelect={onSelect}
                    filter filterMode="strict"
                    filterPlaceholder="Localizar no menu"
                    className="w-full bg-slate-100 rounded-lg p-4 text-blue-500 custom-tree-selecionado"

                    nodeTemplate={(node) => {
                        let tipMessage = "";
                        const isSelected = selectedNodeKey === node.key;
                        const textColor = isSelected ? '#fff' : 'primary';

                        if ('tip' in node) {
                            tipMessage = node.tip as string;
                        }
                        return (
                            <div className="tree-tip" data-pr-tooltip={tipMessage ? `${tipMessage}` : ""}>
                                <Typography color={textColor} variant="body0" gutterBottom={false}>
                                    {node.label}
                                </Typography>
                            </div>



                        );
                    }}
                />


            </div >
        </>
    );

};
